import { useEffect, useState } from "react";
import useDeviceDetect from "./use-device-detect";



export function useScroll() {
    const [scrollTop, setScrollTop] = useState(window.innerHeight + window.scrollY)
    const [scrollTopNative, setScrollTopNative] = useState(window.scrollY)
    const [scrollHeight, setScrollHeight] = useState<number|Boolean>(false);
    const [scrollDirection, setScrollDirection] = useState< 'up' | 'down' | null> (null)
    const [scrolledPercentage, setScrolledPercentage] = useState(0)
    const { isWindowResizing } = useDeviceDetect();
    let oldValue = 0;
    useEffect(()=> {
        setScrollHeight(document.documentElement.scrollHeight)
        document.addEventListener('scroll', () => {
            const scrolledPercentage =  (window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * 100
            const scrollTop = window.innerHeight + window.scrollY;
            const scrollOffsetPosition = window.scrollY;
            if(oldValue - scrollOffsetPosition < 0) {
                setScrollDirection('up');
            } else if( oldValue - scrollOffsetPosition  > 0) {
                setScrollDirection('down')
            }
            oldValue = scrollOffsetPosition;
            setScrollTop(scrollTop)
            setScrolledPercentage(scrolledPercentage)
            setScrollTopNative(window.scrollY)
            
        })

        return () => {
            document.removeEventListener('scroll', () => {
                const scrolledPercentage =  (window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * 100
                const scrollTop = window.innerHeight + window.scrollY
                setScrollTop(scrollTop)
                setScrolledPercentage(scrolledPercentage)
                setScrollTopNative(window.scrollY)
            })
        }
    },[])

    useEffect(()=> {
        setScrollHeight(document.documentElement.scrollHeight)
    },[isWindowResizing])

    return { scrollTop, scrollTopNative , scrollHeight, scrolledPercentage,scrollDirection }
}